module.exports = __webpack_public_path__ + "img/14.352faad0.svg";